module.exports = __webpack_public_path__ + "static/media/playStore.6fec8523.svg";